// extracted by mini-css-extract-plugin
export default {"card":"CheckoutSummary_card__eUgJD","text":"CheckoutSummary_text__A2RqX"};